import { render, staticRenderFns } from "./FormGetWidget.vue?vue&type=template&id=197ba176&scoped=true&"
import script from "./FormGetWidget.vue?vue&type=script&lang=js&"
export * from "./FormGetWidget.vue?vue&type=script&lang=js&"
import style0 from "./FormGetWidget.vue?vue&type=style&index=0&id=197ba176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197ba176",
  null
  
)

export default component.exports